export const replaceLocationWithReferrerQueries = (location: Location, referrer: string) => {
  try {
    const referrerQuery = referrer.split('?')[1];
    if (location.search || !referrerQuery) {
      return JSON.parse(JSON.stringify(location));
    }
    return JSON.parse(JSON.stringify({ ...location, search: `?${referrerQuery}` }));
  } catch {
    return JSON.parse(JSON.stringify(location));
  }
};

export const getLandingLocation = (() => {
  if (!window || !document) {
    return {};
  }
  return replaceLocationWithReferrerQueries(window.location, document.referrer);
})();
